<template>
  <div class="flex flex-col md:overflow-hidden md:h-screen">
    <header class="fixed pin-l w-full z-20 lg:hidden bg-gray-800 text-white">
      <button class="block text-gray-400 hover:text-gray-200 px-4 py-3" @click="open()">
        <svg viewBox="0 0 24 24" fill="currentColor" class="h-6 w-6">
          <path
            d="M3 6a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1zM3 12a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1zM4 17a1 1 0 100 2h7a1 1 0 100-2H4z"
          />
        </svg>
      </button>
    </header>

    <div class="flex flex-1 overflow-hidden">
      <aside
        class="fixed lg:static lg:block inset-y-0 left-0 w-full sm:w-64 bg-gray-700 text-white z-20 justify-between shadow"
        :class="navOpen ? '': 'hidden'"
      >
        <div class="absolute top-0 left-0 pl-4 pt-3 lg:hidden">
          <button class="block" @click="close()">
            <svg viewBox="0 0 24 24" fill="currentColor" class="h-6 w-6">
              <path
                d="M17.293 18.707a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 00-1.414-1.414L12 10.586 6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 101.414 1.414L12 13.414l5.293 5.293z"
              />
            </svg>
          </button>
        </div>

        <div class="flex flex-col h-full pt-10 lg:pt-0">
          <account v-slot:default="{ currentAccount, loading, accounts }">
            <div class="flex justify-between w-full relative">
              <div class="w-full">
                <div class="relative m-4 mb-8">
                  <dropdown>
                    <template v-slot:handle>
                      <div
                        class="flex items-center hover:bg-70 rounded justify-between cursor-pointer"
                      >
                        <div class="flex items-center justify-between w-full">
                          <div class="flex items-center min-w-0">
                            <div
                              v-if="!loading"
                              class="flex flex-shrink-0 w-10 h-10 bg-gray-900 rounded justify-center items-center text-white text-2xl"
                            >{{currentAccount.company_name.charAt(0)}}</div>
                            <div class="ml-4 pr-4 w-64 w-full min-w-0" v-if="!loading">
                              <div class="truncate">{{currentAccount.company_name}}</div>
                              <div class="text-sm font-light">ID #{{currentAccount.id}}</div>
                            </div>
                          </div>

                          <font-awesome-icon icon="chevron-down"></font-awesome-icon>
                        </div>
                      </div>
                    </template>
                    <template v-slot:dropdown>
                      <div
                        class="absolute bg-white ml-10 text-gray-900 w-64 rounded shadow-lg border mt-2"
                        v-if="!loading"
                      >
                        <a
                          v-for="account in accounts"
                          :key="account.id"
                          :href="`/${account.id}`"
                          class="flex border-b p-4 justify-between items-center hover:bg-gray-100"
                        >
                          <div
                            class="text truncate mr-2 font-semibold text-sm"
                          >{{account.company_name}}</div>

                          <div class="text-sm font-light flex-shrink-0">ID #{{account.id}}</div>
                        </a>
                      </div>
                    </template>
                  </dropdown>
                </div>
              </div>
            </div>
          </account>

          <div class="flex flex-col flex-1 overflow-auto">
            <div class="md:block">
              <slot name="before-menu"></slot>
            </div>
            <div class="lg:overflow-auto flex-grow mx-4 md:block">
              <slot name="navigation"></slot>
            </div>

            <div class="mt-8 p-6 border-t border-gray-600">
              <div class="flex flex-no-shrink items-center">
                <font-awesome-icon icon="user-circle" size="2x"></font-awesome-icon>

                <div
                  class="ml-4 truncate"
                >{{user.idTokenParsed.given_name }} {{user.idTokenParsed.family_name}}</div>
              </div>

              <div class="mt-4">
                <a :href="user.createAccountUrl()" class="block mb-2">Profil</a>
                <a :href="user.createLogoutUrl()" class="block">Ausloggen</a>
              </div>
            </div>
          </div>
        </div>
      </aside>

      <main class="overflow-y-auto overflow-x-hidden flex-1 px-4 md:p-10 py-10 mt-10 lg:mt-0">
        <slot name="page"></slot>
      </main>
    </div>
  </div>
</template>

<script>
import Account from "./Account";
import Dropdown from "./Dropdown";

export default {
  components: { Account, Dropdown },
  data() {
    return {
      navOpen: false
    };
  },

  computed: {
    user() {
      return this.$store.state.authentication.keycloak;
    }
  },

  methods: {
    open() {
      document.body.classList.add("h-100");
      document.body.classList.add("overflow-hidden");
      this.navOpen = true;
    },
    close() {
      document.body.classList.remove("h-100");
      document.body.classList.remove("overflow-hidden");
      this.navOpen = false;
    }
  },

  mounted() {
    this.$watch(() => this.$route.path, () => this.close());
  },

  destroyed() {
    //Remove classes from body before destroying component
    this.close();
  }
};
</script>
